import { useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import './Login.css'

export function Login() {
  const [loading, setLoading] = useState(false)
  const { loginWithRedirect } = useAuth0()

  const handleLogin = async () => {
    setLoading(true)
    try {
      await loginWithRedirect()
    } catch (error) {
      console.error('Error during Auth0 login', error)
      setLoading(false)
    }
  }

  return (
    <div className="login-container">
      {/* Logo */}
      <div className="text-center">
        <img
          alt="Logo"
          src={toAbsoluteUrl('/media/imgv2/logo_blanco.png')}
          className="login-logo"
        />
      </div>

      {/* Title */}
      <p className="login-title">Sign In</p>

      {/* Login Button */}
      <div className="d-flex justify-content-center mt-4">
        <button
          type="button"
          className="login-button"
          onClick={handleLogin}
          disabled={loading}
        >
          {!loading && <span className="indicator-label">Log In</span>}
          {loading && (
            <span className="indicator-progress" style={{ display: 'block' }}>
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
      </div>
    </div>
  )
}
